<template>
    <div>
    <form @submit.prevent="submitPrevent" id="form" name="pricing_form"
          ref="pricing_form" class="content-inner formValidation">
    <div class="row">
        <div class="col-12" v-if="!is_reviewing">
            <div class="panel-sub-heading headingLarge">
                <span class="h5 display-6 markedBottom bold">{{ lang('pricing') }}
                </span>

            </div>
        </div>
        <div id="pricing-error" class="col-12" v-if="pricing_error">
            <np-notice :notice="pricing_error" :notice-class="'alert-danger'"></np-notice>
        </div>
        <div id="service-fees" class="col-12">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <span>
                        {{ lang('elavon_service_fees') }}
                    </span>
                </div>
                <div class="row" v-if="loading" >
                    <np-skeleton class="col-12" :type="'fees'"></np-skeleton>
                </div>
                <div class="row" v-else-if="!loading && !!quote && !!quote.acquiring_offer && !!quote.acquiring_offer.service_items">
                   <template v-if="quote.acquiring_offer.service_items.length > 0 ">
                    <template v-for="(service_item, service_idx) in quote.acquiring_offer.service_items">
                        <div class="col-6 col-md-6 col-lg-4" v-show="service_item.is_invisible == '0'
                            && service_item.is_hidden_by_fee_control !== '1'">
                            <div class="card marginBottom20"
                                 :class="{'card--selected-pricing': service_item.is_boarding_activated == '1'}">
                                <div class="card-header card-header--pricing">
                                    <div class="row">
                                        <div class="col-12">
                                            <np-checkbox
                                                    :id="`service_items_${service_idx}_selected`"
                                                    :name="`service_items[${service_idx}][selected]`"
                                                    :description="service_item.service_item_name"
                                                    :no-wrapper="true"
                                                    :help-text="!!service_item.help_text ? service_item.help_text : ''"
                                                    :rules="[{requireOneOfFields: '', 'one-of-group': 'service_item'}]"
                                                    :disabled="service_item.is_mandatory == '1'"
                                                    @change="setSelectedCardBorder($event, `service_items_${service_idx}_selected`)"
                                                    v-model="service_item.is_boarding_activated"
                                            ></np-checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row fee-block marginBottom10">
                                        <div class="col-12">
                                            {{formatServiceFrequency(service_item.service_frequency)}}
                                        </div>
                                        <template v-if="!!service_item.service_item_charges">
                                        <div class="col-12 fee-name" v-for="(service_item_charge) in service_item.service_item_charges">
                                            <div class="fontSize15 display-inline-block">
                                                <span>{{ getPricingFee(service_item_charge,service_item) }} </span>
                                            </div>
                                        </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    </template>
                    <div v-else class="col-12">
                        <np-notice :notice-class="'alert-info'" :notice="lang('no_pricing_available')"
                                   :dismissable="false"
                        ></np-notice>
                    </div>
                </div>
            </div>
        </div>
        <div id="transaction-fees" class="col-12">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <span>
                        {{ lang('elavon_transaction_fees') }}
                        <span v-if="!!getTooltipText('elavon_transaction_fees_help_text') && getTooltipText('elavon_transaction_fees_help_text').length > 0"
                              :title="lang('elavon_transaction_fees')"
                              :data-popover-content="getTooltipText('elavon_transaction_fees_help_text')"
                              style="display: inline-block; padding: 0;"
                              class="helpBtn addPopover helpHeader">
                            <i tabindex="-1" class="fa fa-info-circle"></i>
                        </span>
                    </span>
                </div>
                <div class="row">
                    <np-input :no-wrapper="true" :id="'section'" :name="'section'" :type="'hidden'" model-value="PRICING"></np-input>
                    <template v-if="mode === 'card'">
                        <template v-if="!loading && !!quote.acquiring_offer && !!quote.acquiring_offer.charge_items">
                        <template v-for="(charge_item, charge_idx) in quote.acquiring_offer.charge_items">
                            <div :class="{'col-6 col-md-6 col-lg-6': quote.acquiring_offer.charge_items.length < 3,'col-4 col-md-4 col-lg-4': quote.acquiring_offer.charge_items.length > 2} "
                                 v-show="charge_item.is_invisible == '0'">
                                <div class="card marginBottom20" :class="{'card--selected-pricing': charge_item.is_boarding_activated == '1'}">
                                    <div class="card-header card-header--pricing">
                                        <div class="row">
                                            <div class="col-10">
                                                {{charge_item.is_hidden_by_fee_control}}
                                                <np-checkbox
                                                        :id="`charge_items_${charge_idx}_selected`"
                                                        :name="`charge_items[${charge_idx}][selected]`"
                                                        :description="charge_item.charge_item_name"
                                                        :no-wrapper="true"
                                                        :checked="charge_item.is_mandatory"
                                                        :rules="[{requireOneOfFields: '', 'one-of-group': 'charge_items'}]"
                                                        :disabled="charge_item.is_mandatory == '1'"
                                                        @change="setSelectedCardBorder($event, `charge_items_${charge_idx}_selected`)"
                                                        v-model="charge_item.is_boarding_activated"
                                                ></np-checkbox>
                                            </div>
                                            <div class="col-2">
                                                <span style="float: right;  margin-top: -6px;" :class="getCardType(charge_item.charge_item_name)"></span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="card-body">
                                        <div class="row fee-block marginBottom10">
                                            <div class="col-6"  v-for="(tier, index) in charge_item.charge_item_prices">
                                                <!--     TODO confim tier to show? Display first tier price only for now-->
                                                <template v-if="index == 0">
                                                <div class="row"  v-for="(tier_charge) in tier.charge_item_price_charges">
                                                    <div class="col-12 fee-name">
                                                        <span v-if="tier_charge.category == 1">{{lang('secure_rate')}}</span>
                                                        <span v-else>{{lang('non_secure_rate')}}</span>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="fontSize15 display-inline-block">
                                                            <span>{{getPricingFee(tier_charge, charge_item)}} </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        </template>
                        <np-skeleton class="col-12" v-if="loading" :type="'pricing'"></np-skeleton>
                        <div v-if="!loading && !!quote.acquiring_offer.charge_items && quote.acquiring_offer.charge_items.length < 1" class="col-12">
                            <np-notice :notice-class="'alert-info'" :notice="lang('no_pricing_available')"
                                       :dismissable="false"
                            ></np-notice>
                        </div>
                    </template>
                    <template v-if="mode === 'table'">
                        <div class="col-12" v-if="!loading && !!quote.acquiring_offer && !!quote.acquiring_offer.charge_items">
                            <div class="panel-body">
                                <table class="table table-shades"  >
                                <colgroup>
                                    <col class="col-md-020p">
                                    <col v-show="!has_interchange && show_charge.SHOW_SEC_RATE" class="col-md-020p">
                                    <col v-show="!has_interchange && show_charge.SHOW_SEC_BASE" class="col-md-020p">
                                    <col v-show="!has_interchange && show_charge.SHOW_NON_SEC_RATE && !isSimplifiedPricing" class="col-md-020p">
                                    <col v-show="!has_interchange && show_charge.SHOW_NON_SEC_BASE && !isSimplifiedPricing" class="col-md-020p">
                                    <col v-show="has_interchange" class="col-md-020p">
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>{{lang('card')}}</th>
                                    <th v-show="!has_interchange && show_charge.SHOW_SEC_RATE">
                                       <span style="padding: 0px">
                                            {{isSimplifiedPricing ? lang('msc_rate') : lang('secure_rate')}}
                                           <span
                                                   v-if="isSimplifiedPricing ?
                                                      !!getTooltipText('msc_rate_help_text') && getTooltipText('msc_rate_help_text').length > 0 :
                                                      !!getTooltipText('secure_rate_help_text') && getTooltipText('secure_rate_help_text').length > 0"
                                                   :title="isSimplifiedPricing ? lang('msc_rate') : lang('secure_rate')"
                                                   :data-popover-content="isSimplifiedPricing ?
                                                         getTooltipText('msc_rate_help_text') :
                                                         getTooltipText('secure_rate_help_text')"
                                                   style="display: inline-block; padding: 0;"
                                                   class="helpBtn addPopover helpHeader">
                                                <i tabindex="-1" class="fa fa-info-circle"></i>
                                            </span>
                                        </span>
                                    </th>
                                    <th v-show="!has_interchange && show_charge.SHOW_SEC_BASE">
                                        <span style="padding: 0px">
                                            {{isSimplifiedPricing ? lang('msc_base') : lang('secure_base')}}
                                           <span
                                                   v-if="isSimplifiedPricing ?
                                                      !!getTooltipText('msc_base_help_text') && getTooltipText('msc_base_help_text').length > 0 :
                                                      !!getTooltipText('secure_base_help_text') && getTooltipText('secure_base_help_text').length > 0"
                                                   :title="isSimplifiedPricing ? lang('msc_base') : lang('secure_base')"
                                                   :data-popover-content="isSimplifiedPricing ?
                                                     getTooltipText('msc_base_help_text') :
                                                     getTooltipText('secure_base_help_text')"
                                                   style="display: inline-block; padding: 0;"
                                                   class="helpBtn addPopover helpHeader">
                                                <i tabindex="-1" class="fa fa-info-circle"></i>
                                            </span>
                                        </span>
                                    </th>
                                    <th v-show="!has_interchange && show_charge.SHOW_NON_SEC_RATE && !isSimplifiedPricing">
                                       <span style="padding: 0px">
                                            {{lang('non_secure_rate')}}
                                           <span
                                                   v-if="!!getTooltipText('non_secure_rate_help_text') && getTooltipText('non_secure_rate_help_text').length > 0"
                                                   :title="lang('non_secure_rate')"
                                                   :data-popover-content="getTooltipText('non_secure_rate_help_text')"
                                                   style="display: inline-block; padding: 0;"
                                                   class="helpBtn addPopover helpHeader">
                                                <i tabindex="-1" class="fa fa-info-circle"></i>
                                            </span>
                                        </span>
                                    </th>
                                    <th v-show="!has_interchange && show_charge.SHOW_NON_SEC_BASE && !isSimplifiedPricing">
                                        <span style="padding: 0px">
                                            {{lang('non_secure_base')}}
                                           <span
                                                   v-if="!!getTooltipText('non_secure_base_help_text') && getTooltipText('non_secure_base_help_text').length > 0"
                                                   :title="lang('non_secure_base')"
                                                   :data-popover-content="getTooltipText('non_secure_base_help_text')"
                                                   style="display: inline-block; padding: 0;"
                                                   class="helpBtn addPopover helpHeader">
                                                <i tabindex="-1" class="fa fa-info-circle"></i>
                                            </span>
                                        </span>
                                    </th>
                                    <th v-show="has_interchange">
                                        <span style="padding: 0px">
                                            {{lang('interchange_rate')}}
                                           <span
                                               v-if="!!getTooltipText('interchange_transactions_help_text') && getTooltipText('interchange_transactions_help_text').length > 0"
                                               :title="lang('interchange_rate')"
                                               :data-popover-content="getTooltipText('interchange_transactions_help_text')"
                                               style="display: inline-block; padding: 0;"
                                               class="helpBtn addPopover helpHeader">
                                                <i tabindex="-1" class="fa fa-info-circle"></i>
                                            </span>
                                        </span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(charge_item, charge_idx) in charges">
                                    <template v-if="charge_item.is_hidden_by_fee_control !== '1'">
                                         <td>
                                             <div>
                                                     <div style="float: left">
                                                         <np-checkbox
                                                             style="margin-bottom: -18px;"
                                                             :id="`charge_items_${charge_idx}_selected`"
                                                             :name="`charge_items[${charge_idx}][selected]`"
                                                             :description="charge_item.charge_item_name"
                                                             :no-wrapper="true"
                                                             :checked="charge_item.is_mandatory"
                                                             :rules="[{requireOneOfFields: '', 'one-of-group': 'charge_items'}]"
                                                             :disabled="charge_item.is_mandatory == '1'"
                                                             @change="setSelectedCardBorder($event, `charge_items_${charge_idx}_selected`)"
                                                             v-model="charge_item.is_boarding_activated"
                                                         ></np-checkbox>
                                                     </div>
                                                     <div v-if="isSimplifiedPricing && !!charge_item.charge_item_help_text && charge_item.charge_item_help_text.length > 0" style="float: right">
                                                         <span
                                                             :title="lang('description')"
                                                             :data-popover-content="charge_item.charge_item_help_text"
                                                             style="display: inline-block; padding: 0;"
                                                             class="helpBtn addPopover helpHeader">
                                                            <i tabindex="-1" class="fa fa-info-circle"></i>
                                                        </span>
                                                     </div>
                                                 </div>
                                        </td>
                                        <td v-show="!has_interchange && show_charge.SHOW_SEC_RATE" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('secure_charge_rate') ? charge_item.formatted_charges['secure_charge_rate'] : 'N/A'}}</td>
                                        <td v-show="!has_interchange && show_charge.SHOW_SEC_BASE" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('secure_charge_base') ? charge_item.formatted_charges['secure_charge_base'] : 'N/A'}}</td>
                                        <td v-show="!has_interchange && show_charge.SHOW_NON_SEC_RATE && !isSimplifiedPricing" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('non_secure_charge_rate') ? charge_item.formatted_charges['non_secure_charge_rate'] : 'N/A'}}</td>
                                        <td v-show="!has_interchange && show_charge.SHOW_NON_SEC_BASE && !isSimplifiedPricing" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('non_secure_charge_base') ? charge_item.formatted_charges['non_secure_charge_base'] : 'N/A'}}</td>
<!--                                            <td v-show="!has_interchange" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('secure_charge') ? charge_item.formatted_charges['secure_charge'] : 'N/A'}}</td>-->
<!--                                            <td v-show="!has_interchange" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('unsecure_charge') ? charge_item.formatted_charges['unsecure_charge'] : 'N/A'}}</td>-->
                                        <td v-show="has_interchange" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('interchange_charge') ? charge_item.formatted_charges['interchange_charge'] : 'N/A'}}</td>
                                    </template>
                                </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        <np-skeleton class="col-12" v-if="loading" :type="'line_pricing'"></np-skeleton>
                        <div v-if="!loading && !!quote.acquiring_offer.charge_items && quote.acquiring_offer.charge_items.length < 1" class="col-12">
                            <np-notice :notice-class="'alert-info'" :notice="lang('no_pricing_available')"
                                       :dismissable="false"
                            ></np-notice>
                        </div>
                    </template>

                </div>
            </div>
        </div>
        <template v-if="isSimplifiedPricing && hrlValue">
          <div class="col-12">
            <div class="panel-body">
              <table class="table table-shades" >
                <colgroup>
                  <col class="col-md-020p" >
                  <col v-show="show_charge.SHOW_SEC_RATE" class="col-md-020p" >
                  <col v-show="show_charge.SHOW_SEC_BASE" class="col-md-020p" >
                </colgroup>
                <tbody>
                <tr>
                  <td>
                    <div>
                      <div style="float: left">
                        <span>{{lang('high_risk_loading_rate')}}</span>
                      </div>
                      <div style="float: right">
                            <span v-if="!!getTooltipText('hrl_help_text') && getTooltipText('hrl_help_text').length > 0"
                                  :title="lang('high_risk_loading_rate')"
                                  :data-popover-content="getTooltipText('hrl_help_text')"
                                  style="display: inline-block; padding: 0;"
                                  class="helpBtn addPopover helpHeader">
                              <i tabindex="-1" class="fa fa-info-circle"></i>
                            </span>
                      </div>
                    </div>
                  </td>
                  <td v-show="show_charge.SHOW_SEC_RATE">
                    <span>
                      {{hrlValue}}
                    </span>
                  </td>
                  <td v-show="show_charge.SHOW_SEC_BASE"></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
    </div>

    <template v-if="loading_finished">
        <div class="row mt-4" style="border-top: 1px solid #b2c6d0"  v-if="is_reviewing && !isLockedQuote" >
            <div class="col-12">
                <div class="my-3">
                    <a class="btn btn-default" @click="updateQuote"> {{lang('save')}}</a>
                </div>
            </div>
        </div>
        <div class="row mt-4" style="border-top: 1px solid #b2c6d0" v-if="!is_reviewing">
            <div class="col-12">
                <div class="my-3">
                    <button type="button" class="btn btn-danger me-1" @click="goBack"> {{lang('go_back')}}</button>
                    <button type="button" class="btn btn-default me-1" @click="doContinue" :disabled="disableContinueBtn"> {{ !isConvertedQuote ? lang('confirm_quote') : lang('continue')}} {{ !!disableContinueBtn ? '...' : ''}}</button>
                </div>
            </div>
        </div>
    </template>
    </form>

    <div id="email-sms-otp-modal" class="modal" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{lang('otp_header')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label="lang('close')" @click="onCloseVerifyOtpModal">
                    </button>
                </div>
                <div class="modal-body py-2">
                    <form @submit.prevent="submitPrevent" id="confirm-email-sms-otp-form" name="confirm_email_sms_otp_form" class="content-inner formValidation">
                        <div class="row" id="email-sms-otp-Row">
                            <div class="col-12">
                               {{ lang('otp_header_send_to') }}
                            </div>
                            <div class="col-12">
                                <np-input
                                    :name="'contact_email_address'"
                                    :id="'contact_email_address'"
                                    :addon-on-left="true"
                                    :disabled="true"
                                    :model-value="quote.email_address">
                                    <template #addon>
                                    <span><i class="fa fa-envelope"></i></span>
                                    </template>
                                </np-input>
                            </div>
                            <div class="col-12">
                                <np-input
                                    :name="'contact_phone_no'"
                                    :id="'contact_phone_no'"
                                    :addon-on-left="true"
                                    :disabled="true"
                                    :model-value="`${formatPhoneCode(quote.ent_telephone_code)}-${quote.telephone_number}`">
                                    <template #addon>
                                    <span><i class="fa fa-sms"></i></span>
                                    </template>
                                </np-input>
                            </div>
                            <div class="col-12 mt-3">
                                {{ lang('otp_body_send_to') }}
                            </div>
                            <div class="col-10 offset-3 mb-2">
                                <np-radios
                                    :id="'opt_with'"
                                    :name="'opt_with'"
                                    :check_config="false"
                                    :mode="'separate'"
                                    :required="true"
                                    :options="parameters.OTP_OPTIONS"
                                    v-model="quote.opt_with">
                                </np-radios>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10 offset-1 mb-3">
                                <button type="button" id="go-next-otp-modal" class="btn btn-default btn-block display-block" @click="confirmEmailSMSOTP()">{{lang('next')}}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div id="set-password-modal" class="modal" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{lang('otp_header')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label="lang('close')" @click="onCloseVerifyOtpModal">
                    </button>
                </div>
                <div class="modal-body py-2">
                    <form @submit.prevent="submitPrevent" id="set-password-form" name="set_password_form" class="content-inner formValidation">
                        <div class="row" id="set-password-Row">
                            <div class="col-12">
                               {{ lang('otp_header_send_to') }}
                            </div>
                            <div class="col-12">
                                <np-input
                                    :name="'contact_email_address'"
                                    :id="'contact_email_address_mfa'"
                                    :addon-on-left="true"
                                    :disabled="true"
                                    :model-value="quote.email_address">
                                    <template #addon>
                                    <span><i class="fa fa-envelope"></i></span>
                                    </template>
                                </np-input>
                            </div>
                            <div class="col-12">
                                <np-input
                                    :id="'new_password'"
                                    :name="'new_password'"
                                    :label="lang('placeholder_password')"
                                    :placeholder="lang('placeholder_password')"
                                    :no-wrapper="true"
                                    :addon-on-left="true"
                                    :required="true"
                                    :maxlength="20"
                                    :minlength="12"
                                    :rules="['valid_password', {'confirm_password_lazy': '1'}]"
                                    aria-autocomplete="off"
                                    type="password"
                                    v-model="quote.new_password">
                                    <template #addon>
                                    <span><i class="fa fa-lock"></i></span>
                                    </template>
                                </np-input>
                                <np-input
                                    :id="'conf_password'"
                                    :name="'conf_password'"
                                    :label="lang('placeholder_conf_password')"
                                    :placeholder="lang('placeholder_conf_password')"
                                    :no-wrapper="true"
                                    :addon-on-left="true"
                                    :required="true"
                                    :maxlength="20"
                                    :minlength="12"
                                    :rules="[{'confirm_password_lazy': '2'}]"
                                    aria-autocomplete="off"
                                    type="password"
                                    v-model="quote.conf_password">
                                    <template #addon>
                                    <span><i class="fa fa-lock"></i></span>
                                    </template>
                                </np-input>
                            </div>
                            <div class="col-12 my-3">
                                {{ lang('otp_body_send_email') }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10 offset-1 mb-3">
                                <button type="button" id="go-next-otp-modal-mfa" class="btn btn-default btn-block display-block" @click="confirmSetPasswordOTP()">{{lang('next')}}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

        <div id="verify-otp-modal" class="modal" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{lang('verify_otp')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label="lang('close')" @click="onCloseVerifyOtpModal">
                        </button>
                    </div>
                    <div class="modal-body py-3">
                        <form @submit.prevent="submitPrevent" id="confirm-new-user-form" name="confirm_new_user_form" class="content-inner">
                            <div class="row">
                                <div class="col-12">
                                    <p>
                                        {{ lang('login_onetime_pass_login_msg') }}
                                    </p>
                                </div>
                            </div>
                            <div class="row" id="onetimepasswordRow">
                                <div class="col-12">
                                    <np-input
                                        :label="lang('enter_verification_code')"
                                        :id="'onetime_password'"
                                        :name="'onetime_password'"
                                        :no-wrapper="true"
                                        :required="true"
                                        :check_config="false"
                                        type="password"
                                        autocomplete="off"
                                        v-model="user_verify.onetime_password">
                                        <template #addon>
                                        <span><span class="otpTime" data-expire-in="30"><span class="mins">30</span>:<span class="secs">00</span></span></span>
                                        </template>
                                        <template #addon2>
                                        <span><i class="fa fa-lock"></i></span>
                                        </template>
                                    </np-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-12 mb-3">
                                    <button type="button" class="btn btn-default btn-block resendOTP display-block displayNone" @click="resendOTP(true)">{{lang('resend_otp')}}</button>
                                    <button type="button" class="btn btn-default btn-block submitOTPBtn display-block" @click="convertPublicQuote">{{lang('confirm')}}</button>
                                </div>

                                <div class="col-12 displayNone" id="resend-otp-click-here">
                                    <p>
                                        {{lang('resend_otp')}} ? <a href="#" @click="resendOTP">{{lang('click_here')}}</a>
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
<!--        <button @click="showVerifyOTPModal">show modal</button>-->
    </div>
</template>

<script>
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import {
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker,
        NPInput,
        NPModal, NPNotice, NPPhone, NPPostcodeSearch,
        NPRadios, NPResponsive,
        NPSelect2, NPSkeleton,
        NPTextArea, NPVat
    } from "netpify/components";
    import pricingMixin from "../../../utils/pricing-mixin";
    import * as types from "../../../stores/constants";
    import loginMixin from "../../../utils/login-mixin";
    import useModuleStore from "../../../stores";

    export default {
        name: "Pricing",
        mixins: [utilMixin, applicationMixin, pricingMixin, loginMixin],
        components: {
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
            'np-notice': NPNotice,
        },
        data() {
            return {
                mode: 'table', //can be card mode
                page_label: 'take_a_look_at_your_pricing',
                loading: true,
                abortRouteLeave:false,
                user_verify: {
                    user_ref: '',
                    onetime_password: '',
                },
                password_form: {
                    new_password: '',
                    conf_password: '',
                },
            }
        },
        metaInfo() {
            return {
                title: this.lang('pricing')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.setAppPageTitle(vm.page_label);
                //check if there is a fee control to hide some acquiring charges.
                //Be noted it works when entering into this page from other tabs. But if refresh the page, the
                //equpmentoffer/onlineoffer is null as they were set later. So add additional function after the offer data was set
                vm.feeControlProcess();
            });
        },
        beforeRouteLeave(to, from, next) {
            // if(this.abortRouteLeave){
            //     next();
            //     return; //prevent it from doing anything else
            // }

            if(!this.checkDestinationRoute(to, from)){ //if user is going backwards, don't validate
                if (this.pageHasData() && !this.disable_go_back_warning_modal) {
                    this.alertBackRouteWarning((doCall = true) => next(doCall))
                } else {
                    next()
                    return;
                }
            }else {
               if(this.isLockedQuote) {
                   next(true);
               } else {
                   if(!this.inQuoteViewMode) {
                       // If edit quote do validate and save
                       this.updateQuote(() => {next()})
                   }else{
                       next(true)
                   }
               }
            }
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        mounted() {
            this.disableContinueBtn = false;

            let use_mfa = false;
                const alliance = vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null;
                if (alliance) {
                    use_mfa = alliance.hasOwnProperty('mfa_type') && [types.MFA_METHOD_PING, types.MFA_METHOD_PING_PREFERRED].includes(alliance.mfa_type)
                } else {
                    this.notifyError(this.lang('validation_error'), this.lang('tenant_not_found'))
                    return false;
                }
            const convert_quote_form_id = use_mfa ? '#set-password-form' : '#confirm-email-sms-otp-form'
            setTimeout(function () {
                $(convert_quote_form_id).formValidator({
                    // triggerElement: '', //trigger element default $('form').find('button[type="submit"]')
                    triggerEvent: '', // event - default 'click'
                    defaultConfig: '', // {} - object to set different configuration in validate.js
                    scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                    additionalCallbackFunction: '',
                });
            }, 1000);
        },
        created() {
            // this.getAcquiringOffer();
        },
        computed: {
            loading_finished: function () {
                return !this.loading;
            },
            updatedUser: function () {
                if (
                    !!this.application_users
                    && this.application_users.hasOwnProperty(this.user.user_external_id)
                ) {
                        return this.application_users[this.user.user_external_id];
                }
                return this.user;
            },
        },
        methods: {
            // formatOTPOptions: function (data){
            //     let value = this.formatOptionType(this.parameters, data, 'OTP_OPTIONS');

            //     if (value === 'SMS'){
            //         return this.lang('phone_number')
            //     }

            //     return value;
            // },
            goBack: function (){
                this.abortRouteLeave = true;
                this.$router.push({path: this.quote_root_path + 'business/products/'})
            },
            doContinue: function () {
                let vm = this;
                const path_to = vm.application_root_path + 'business_details/';

                let use_mfa = false;
                const alliance = vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null;
                if (alliance) {
                    use_mfa = alliance.hasOwnProperty('mfa_type') && [types.MFA_METHOD_PING, types.MFA_METHOD_PING_PREFERRED].includes(alliance.mfa_type)
                } else {
                    vm.notifyError(vm.lang('validation_error'), vm.lang('tenant_not_found'))
                    return false;
                }
                if (vm.inQuoteViewMode) {
                    vm.$router.push({path: path_to})
                } else {
                    if (!vm.isConvertedQuote) {
                        //do update then confirm. RouteLeave should only update,never convert cos We can be going to a previous step
                        // show pop-up with email+sms/setpassword otp options if isPublicUser
                        if (vm.isPublicUser) {
                            const convert_quote_modal_id = use_mfa ? '#set-password-modal' : '#email-sms-otp-modal'
                            let modalEl = document.querySelector(convert_quote_modal_id)
                            let modal = bootstrap.Modal.getOrCreateInstance(modalEl)
                            modal.show();
                        } else {
                            vm.updateQuote();
                        }
                    } else {
                        vm.$router.push({path: path_to}) //here the application already exist so path_to will work.
                    }
                }
            },
            pageHasData: function (){
                return this.checkPricingIsSelected(this.quote.acquiring_offer);
            },
            confirmEmailSMSOTP: function (){
                let vm = this;
                let is_valid = vm.validateForm('#confirm-email-sms-otp-form');

                // If not option selected stay on same page
                // If option selected then do --> //update quote
                if (is_valid) {
                    if (vm.objectIsNotEmpty(vm.quote) && !!vm.quote.opt_with) {
                       // $('#email-sms-otp-modal').modal('hide');
                        let modalEl = document.querySelector('#email-sms-otp-modal')
                        let modal = bootstrap.Modal.getOrCreateInstance(modalEl)
                        modal.hide();
                        vm.updateQuote();
                    }
                }
            },
            confirmSetPasswordOTP: function (){
                let vm = this;
                let is_valid = vm.validateForm('#set-password-form');

                // If not option selected stay on same page
                // If option selected then do --> //update quote
                if (is_valid) {
                    if (vm.objectIsNotEmpty(vm.quote)) {
                        let modalEl = document.querySelector('#set-password-modal')
                        let modal = bootstrap.Modal.getOrCreateInstance(modalEl)
                        modal.hide();
                        vm.updateQuote();
                    }
                }
            },
            updateQuote(callback = null){
                let vm = this;
                if (!!this.disableContinueBtn) { //avoid double click
                    return;
                }
                if (vm.validatePricing()) {
                    this.disableContinueBtn = true;
                    let vm = this;
                    //update quote
                    let payload_data = this.jsonCopy(this.quote);
                    if (!!payload_data.equipment_offer) {
                        payload_data.equipment_offer = this.formatEquipmentOfferForWAF(payload_data.equipment_offer);
                    }
                    if (!!payload_data.acquiring_offer) {
                        payload_data.acquiring_offer = this.formatAcquiringOfferForWAF(payload_data.acquiring_offer);
                    }
                    vm[types.UPDATE_QUOTE](payload_data).then(response => {
                        if (response.data.result === 'SUCCESS') {
                            vm.notifySuccess(vm.lang('pricing_updated_successfully'));
                            if (vm.is_reviewing) {
                              vm.$emit('close_review_section');
                            }

                            if (this.isConvertedQuote && !!callback) {
                                callback();
                            }
                            return response;
                        } else {
                            this.disableContinueBtn = false;
                        }
                    }).then(resp => {
                        if (!this.isConvertedQuote && callback === null) { //only do this from the continue button.
                            if (vm.isPublicUser) {
                                vm.createQuoteMerchantUser();
                            } else {
                                const payload = {
                                    'quote_external_id': vm.quote.quote_external_id
                                };
                                vm[types.CONVERT_QUOTE](payload).then(app_response => {
                                    if (!!app_response && app_response['data']['result'] === 'SUCCESS') {
                                        const {application} = app_response.data;
                                        if (!!application) {
                                            vm.notifySuccess(this.lang('quote_converted_successfully'));
                                            let application_reference = application.application_reference;
                                            window.location.href = '/application/edit/' + application_reference + '/business_details/';
                                        }
                                    } else {
                                        this.disableContinueBtn = false;
                                    }
                                });
                            }
                        } else {
                            callback();
                        }
                    }).catch(error => {
                        //console.log(error)
                    });
                }
                this.revertContinueButton();
            },
            validatePricing: function (){
                let form_is_valid = this.validateForm('#form');
                let form = this.getFormData($('#form')), section = form.section;
                this.quote.section = section;

                let is_valid_pricing = false;

                //validate offer package expiration only when quote hasn't been converted.
                if (!this.isConvertedQuote) {
                    if (!this.validateOfferPackagePeriod()) {
                        return false;
                    }
                }

                if (this.objectIsNotEmpty(this.quote.acquiring_offer)) {
                    is_valid_pricing = this.checkPricingIsSelected(this.quote.acquiring_offer);
                    if (!is_valid_pricing) {
                        this.notifyError(this.lang('validation_error'), this.lang('please_select_pricing'))
                        return false;
                    }
                    if(!!this.quote.pricing_has_error){
                        this.notifyError(this.lang('validation_error'), this.lang('cannot_save_pricing'))
                        return false;
                    }
                }
                return form_is_valid;
            },
            convertPublicQuote: function (){
                let vm = this;

                let form_is_valid = this.validateForm('#confirm-new-user-form');
                if (!form_is_valid) {
                    return;
                }
                let modalEl = document.querySelector('#verify-otp-modal')
                let modal = bootstrap.Modal.getOrCreateInstance(modalEl) // Returns a Bootstrap modal instance
                modal.hide();
                // $('#verify-otp-modal').modal('hide');

                const payload = { ...this.user_verify, ...{
                    convert_quote: 1,
                }}

                vm[types.CONVERT_PUBLIC_QUOTE](payload).then(app_response => {
                    if (!!app_response && app_response['data']['result'] === 'SUCCESS') {
                        const {application} = app_response.data;
                        if (!!application) {
                            vm.notifySuccess(this.lang('quote_converted_successfully'))

                            let application_reference = application.application_reference;
                            window.location.href = '/application/edit/' + application_reference + '/business_details/';
                        }
                    } else {
                        this.disableContinueBtn = false;

                        //unset the otp value
                        this.user_verify.onetime_password = '';
                        //throw error
                    }
                });
            },
            showVerifyOTPModal: function (){
              // $('#verify-otp-modal').modal('show');
                let modalEl = document.querySelector('#verify-otp-modal')
                let modal = bootstrap.Modal.getOrCreateInstance(modalEl) // Returns a Bootstrap modal instance
                modal.show();
                clearInterval(this.passwordCounterHandler);
                this.passwordCounter();
            },
            resendOTP: function(show_password_field = false){
                if (!!show_password_field) { //when the time elapses, we hide the field. So the resendOTP button will unhide the field.
                    $('#onetimepasswordRow').removeClass('displayNone');
                    clearInterval(this.passwordCounterHandler);
                    this.passwordCounter();
                }

                this.createQuoteMerchantUser(true);
            },
            createQuoteMerchantUser: function (resend_otp = false){
                let vm = this;
                let payload_data = this.jsonCopy(this.quote);
                if (!!payload_data.equipment_offer) {
                    payload_data.equipment_offer = this.formatEquipmentOfferForWAF(payload_data.equipment_offer);
                }
                if (!!payload_data.acquiring_offer) {
                    payload_data.acquiring_offer = this.formatAcquiringOfferForWAF(payload_data.acquiring_offer);
                }
                vm[types.CREATE_QUOTE_MERCHANT_USER](payload_data).then(response => {
                    if (!!response && response['data']['result'] === 'SUCCESS') {
                        //show modal with user_refernce and verification code fields
                        //they can send and request a new otp.
                        vm.notifySuccess(this.lang('onetime_password_sent_successfully'))

                        let {user} = response.data;
                        vm.user_verify.user_ref = user.user_reference;

                        if (!!resend_otp) {
                            //close modal because loading spinner is going to cover it but keep the background
                            // $('#verify-otp-modal').modal('hide');
                            let modalEl = document.querySelector('#verify-otp-modal')
                            let modal = bootstrap.Modal.getOrCreateInstance(modalEl) // Returns a Bootstrap modal instance
                            modal.hide();
                            let $resendOTP = $('.resendOTP'), $otpTime = $('.otpTime '), $confirmBtn = $('.submitOTPBtn');

                            $resendOTP.addClass('displayNone');
                            $confirmBtn.removeClass('displayNone');
                            $('#resend-otp-click-here').addClass('displayNone');
                            $resendOTP.html(LANGUAGE['resend_otp']);
                        }
                            vm.showVerifyOTPModal()
                        //don't show loading screen in background
                        useModuleStore().commit(types.TOGGLE_LOADING, false);
                    }
                })
            },
            onCloseVerifyOtpModal: function (){
                //the modal can close itself this function clears interval
                this.user_verify.onetime_password = '';
                clearInterval(this.passwordCounterHandler);
                $('#onetimepasswordRow .has-error').removeClass('has-error');
            }
        }
    }
</script>

<style scoped>
    .fontSize15 {
        font-size: 15px;
    }

    .display-inline-block {
        display: inline-block;
    }

    .display-inline {
        display: inline !important;
    }


    .fee-block {
        font-size: 0.85em;
    }

    .fees-circle {
        border-radius: 50%;
        width: 45px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        border: 1px solid cadetblue;
    }

    .fee-row {
        font-size: 12px;
    }

    /*.fee-name {*/
    /*    !*line-height: 45px;*!*/
    /*}*/
    .charge-wrapper {
        text-align: left;
    }
    /*span:not(.markedBottom) {*/
    /*    display: inline-block;*/
    /*    vertical-align: middle;*/
    /*    line-height: normal;*/
    /*}*/
</style>
